import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Folder } from 'src/typings';
import { FolderService } from '../folder.service';

@Component({
  selector: 'app-folder-selector',
  templateUrl: './folder-selector.component.html',
  styleUrls: ['./folder-selector.component.scss']
})
export class FolderSelectorComponent implements OnInit {
  constructor(private folderService: FolderService) {}

  folders: Observable<Folder[]> = this.folderService.getFlatFolders();

  filteredOptions: Observable<Observable<Folder[]>> = new Observable();

  value: any;

  @Input() control: UntypedFormControl = new UntypedFormControl('');

  public displayProperty(brand: any) {
    if (brand) {
      return brand.description;
    }
    return;
  }

  ngOnInit(): void {
    this.filteredOptions = this.control.valueChanges.pipe(
      startWith(''),
      map((value) => this._filter(value))
    );
  }

  private _filter(value: string | Folder): Observable<Folder[]> {
    const lowerValue =
      typeof value === 'string' ? value.toLowerCase() : value?.description.toLowerCase();

    return this.folders.pipe(
      map((brands) =>
        brands.filter((brand) => {
          if (!lowerValue) return true;
          return brand.description.toLowerCase().includes(lowerValue);
        })
      )
    );
  }
}
